
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { gameRoles } from '@/data/roles';
import { Badge } from '@/components/ui/badge';

export const RoleSelectionPreview: React.FC = () => {
  // Only show first three roles in the preview
  const previewRoles = gameRoles.slice(0, 3);
  
  return (
    <div className="w-full">
      <h4 className="text-white font-medium mb-3">Available Career Paths:</h4>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {previewRoles.map((role) => (
          <Card key={role.id} className="bg-web3-blue/20 border border-web3-blue/20">
            <CardContent className="p-4">
              <h5 className="text-web3-green font-medium mb-2">{role.title}</h5>
              <div className="flex flex-wrap gap-2 mb-3">
                {role.startingSkills.slice(0, 2).map((skill) => (
                  <Badge key={skill.id} variant="outline" className="text-xs">
                    {skill.name}
                  </Badge>
                ))}
              </div>
              <p className="text-xs text-white/70 line-clamp-2">{role.description}</p>
            </CardContent>
          </Card>
        ))}
      </div>
      <p className="text-xs text-white/60 mt-2 text-center">
        Preview of 3 out of {gameRoles.length} available roles
      </p>
    </div>
  );
};
